<modal [width]="420" [height]="80" (closeOut)="onClose()">
  <modal-header>
    <span>{{strings.provideYourPassword}}</span>
  </modal-header>
  <modal-body>
    <div class="form-row">
      <div class="form-group col">
        <label class="required" for="password-field">
          {{strings.pleaseProvideYourPasswordToUnmaskTheAnswers}}
        </label>
        <ti-input-validation-wrap [firstSubmit]="firstSubmit" [control]="psw">
          <input
            type="password"
            class="form-control"
            id="password-field"
            name="password"
            ngModel
            required
            #psw="ngModel"
            [title]="miscStrings.password"
          />
        </ti-input-validation-wrap>
      </div>
    </div>
  </modal-body>
  <modal-actions>
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="onClose()">{{miscStrings.cancel}}</button>
    <button kendoButton [primary]="true" (click)="checkPassword(psw.value)"> {{miscStrings.ok}} </button>
  </modal-actions>
</modal>